import script from "./BodyTopMainAppDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyTopMainAppDownload.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodyTopMainAppDownload.vue?vue&type=style&index=0&id=191bfb84&module=bodyTopMainAppDownload&lang=css"
cssModules["bodyTopMainAppDownload"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QImg,QTab});
